import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, MakeContext, ObjContext } from "./context";

export class Cultist extends UnitType {
    readonly id = "cultist";
    readonly displayName = "Cultist";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.overworld; }
    canEnter(ctx: PlaceContext) { return !ctx.world.hasNearbyObj(ctx.x, ctx.y, 3.5, "tower") && this.inTile(ctx, ["land", "tree"], ctx.game.overworld); }
    description() { return "Defeats peasants.\nCan move through trees."; }
    cost() { return { blood: 50, souls: 0, runes: 2 }; }
    img(ctx: UnitContext) { return "cultist_" + ctx.faction; }
    maxCooldown() { return 5000; }
    moveRange() { return 3.5; }
    defeats() { return ["peasant"]; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "cultist"); }
    step(ctx: ObjContext): void {
        if (ctx.faction !== "player") {
            this.hunt(ctx, c => {
                const obj = c.world.get(c.x, c.y);
                return obj && this.canDefeat(obj.unitId) ? 1 : 0;
            });
        }
    }
}
